export const FILE_TYPE_REGEX = /^image\/(jpeg|png)$/;
// eslint-disable-next-line no-magic-numbers
export const MB_10 = 10 * 1024 * 1024;
export const PX_1000 = 1000;
export const IMAGE_TYPE_MESSAGE = "Invalid file type. Please select a JPEG or PNG file.";
export const IMAGE_SIZE_MESSAGE = "Image should not exceed 10MB.";
export const IMAGE_DIMENSIONS_MESSAGE = "Image width or height should not exceed 1000px.";
